/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {listTasks} from '../api'

 export const useQueryListTasks = createReactQueryHook('listTasks', listTasks)
